export default __webpack_public_path__ + "static/media/PrintToDownload.4812e447.png";